var _templateObject = _taggedTemplateLiteralLoose(['\n  font-family: ', ';\n  color: ', ';\n  font-size: ', ';\n  font-weight: 500;\n'], ['\n  font-family: ', ';\n  color: ', ';\n  font-size: ', ';\n  font-weight: 500;\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import styled from 'styled-components';
import Theme from '../../Theme';

export var Headline = styled.h1(_templateObject, Theme.fonts.Montserrat, Theme.colors.primary, function (props) {
  return props.fontSize || '16px';
});